module.exports = __webpack_public_path__ + "static/media/DVLA_app_shape_grey_surround.b3078daa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/DVLA_app_shape_grey_surround.svg
// module id = 598
// module chunks = 0